import React from "react";
import { ADMIN_AUDIT_EVENT_PICKER_ENTRIES } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getMyCSRMistakesStore from "../../../../stores/csr-store/csr-mistakes";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { ISSUES_ARRAY } from "../../../../constants/input-entries-constants";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const MyCSRMistakeForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("TYPE")}
          options={ADMIN_AUDIT_EVENT_PICKER_ENTRIES}
          value={getMyCSRMistakesStore().mistakeType.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getMyCSRMistakesStore().setMistakeType(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ISSUE_TYPE")}
          options={ISSUES_ARRAY}
          value={getMyCSRMistakesStore().issueSeverity.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getMyCSRMistakesStore().setIssueSeverity(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getMyCSRMistakesStore().fromDate}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getMyCSRMistakesStore().toDate}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => await getMyCSRMistakesStore().getMistakes()}
        isEnabled={true}
        size="LARGE"
        type="GET"
        text="GET"
      />
    </React.Fragment>
  );
});
export default MyCSRMistakeForm;
